import React from 'react'

function Button(props) {
  const { className = '', url, type, children } = props

  if (type === 'button') {
    return (
      <button className={className} type="submit">
        {children}
      </button>
    )
  } else {
    return (
      <a className={className} href={url}>
        {children}
      </a>
    )
  }
}

export default Button
